export default __webpack_public_path__ + "static/media/fundo conteudos.12ba32f6.svg";